import { render, staticRenderFns } from "./homeIndex.vue?vue&type=template&id=7d512133&scoped=true"
import script from "./homeIndex.vue?vue&type=script&lang=js"
export * from "./homeIndex.vue?vue&type=script&lang=js"
import style0 from "./homeIndex.vue?vue&type=style&index=0&id=7d512133&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d512133",
  null
  
)

export default component.exports